import request from '@/utils/request3'
import store from '@/store'

const serviceName = store.state.serviceName.wflow

// 发起流程
export function startProcess(data) {
  return request({ url: serviceName + `/wflow/process/start`, method: 'post', data })
}

// 审批(result: 1同意 2拒绝)
export function approve(data) {
  return request({ url: serviceName + `/wflow/process/approve`, method: 'post', data })
}

// 同意
export function agree(data) {
  return request({ url: serviceName + `/wflow/process/agree`, method: 'post', data })
}

// 拒绝
export function reject(data) {
  return request({ url: serviceName + `/wflow/process/reject`, method: 'post', data })
}

// 撤销(仅发起人)
export function revoke(instanceId) {
  return request({ url: serviceName + `/wflow/process/revoke`, method: 'post', params: { instanceId } })
}

// 抄送已读
export function ccRead(taskId) {
  return request({ url: serviceName + `/wflow/process/ccRead`, method: 'post', params: { taskId } })
}

// 流程实例详情
export function getDetail(instanceId) {
  return request({ url: serviceName + `/wflow/process/detail`, method: 'get', params: { instanceId } })
}
